export default "__VITE_ASSET__BHN2J9MZ__"